export interface Stats {
    kills: number;
}
